import { UseFieldConfig } from 'react-final-form';
import { Radio as ARadio, RadioProps } from 'antd';
import { FormControl, FormControlBaseProps } from '../FormControl';

import styles from './Radio.module.scss';

type Props = FormControlBaseProps &
  UseFieldConfig<string> &
  Omit<RadioProps, 'value' | 'onChange'>;

export function Radio({
  className,
  label,
  noHint,
  hint,
  name,
  ...props
}: Props) {
  return (
    <FormControl<string>
      label={label}
      className={className}
      required={props.required}
      name={name}
      noFloat
      hint={hint}
      {...props}
    >
      {({ value, onChange, readOnly }) => (
        <ARadio.Group
          {...props}
          disabled={props.disabled || readOnly}
          className={styles.radio}
          value={value}
          onChange={(e) => onChange(e.target.value as string)}
        />
      )}
    </FormControl>
  );
}

Radio.Button = ARadio.Button;
Radio.Dot = ARadio;
